import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";
import { FutureContractEntity } from "@/pages/grain-requests/future-contract/schema/future-contract.schema";

interface Props {
  item: FutureContractEntity;
  handleDetail: (item: FutureContractEntity) => void;
}

export const FutureContractActions = ({
  handleDetail,
  item,
}: Props) => {
  //Acciones para contrato futuro
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item)}
          data-testid="future-contract-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
